import $ from 'jquery'
import Modernizr from 'modernizr'

function wFlexibleHeader($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $userActionsMenu,
      $userActionsToggler,
      $signInBar,
      $signInBarHeaderButton,
      $signInBarCloseButton,
      $signInToggler,
      $signInForm,
      $emailField,
      $passwordField,
      SIGN_IN_ERROR_HEIGHT = 50,
      userActionsMenuHeight;

  /* PRIVATE METHODS */

  // constructor
  function init() {

    // User Actions Menu
    $userActionsMenu         = $('.w-flexible-header__actions-menu-wrapper', $mainContainer);
    userActionsMenuHeight    = $('.w-flexible-header__actions-menu').outerHeight() + 6;
    $userActionsToggler      = $('.w-flexible-header__actions-signed__user__arrow-down', $mainContainer);

    // Sign In
    $signInBar              = $('.w-flexible-header__row--sign-in', $mainContainer);
    $signInToggler          = $('.w-flexible-header__sign-in-toggler', $mainContainer);
    $signInForm             = $('#new_user_session', $mainContainer);
    $emailField             = $('#user_session_email', $signInForm);
    $passwordField          = $('#user_session_password', $signInForm);
    $signInBarHeaderButton  = $('.w-flexible-header__actions-anonym .w-flexible-header__sign-in-toggler', $mainContainer);
    $signInBarCloseButton   = $('.w-flexible-header__close-wrapper .w-flexible-header__close');

    $('#user_session_email', $signInBar).trigger('blur');

    bindDomElements();
  }

  function bindDomElements() {
    $userActionsToggler.on('click', toggleUserActionsMenu);

    if ($signInBar.length > 0) {
      $signInToggler.on('click', function(e) {
        toggleSignInBar(e);
      });
    }

    if (Modernizr.touchevents) {
      $(window).on('orientationchange', function() {
        closeOpenedBars();
      });
    } else {
      $(window).on('resize', function() {
        closeOpenedBars();
      });
    }

    var addTabindexArray = [$('a', $userActionsMenu),
                            $('a, input, button', $signInForm),
                            $('.w-flexible-header__close')
                            ];

    $.each(addTabindexArray, function(index, element) {
      element.attr('tabindex', '-1');
    });

    $signInForm.formMaterialDesign();
    $signInForm.on('submit', function(e) {
      removeErrorMessage();
      e.preventDefault();

      if (checkRequiredFields()) {
        $('.login_button').prop('disabled', true).addClass('disabled'); // prevent double clicking - disable button

        var xhrData = {
          url: $signInForm.attr('action'),
          type: 'post',
          dataType: 'json',
          data: $signInForm.serialize()
        };

        var callbacks = {
          afterSuccess: function(response) {
            if (response.error) {
              var $error = '<div class="sign-in-error-wrapper"><p class="sign-in-error">' + response.error + '</p></div>'
              $signInBar.find('.w-flexible-header__sign-in-left').prepend($error);
            }
          },
          afterComplete: function() {
            $('.login_button').prop('disabled', false).removeClass('disabled'); // prevent double clicking - enable button
          }
        };

        SOPHIA.sendXHR(xhrData, callbacks);
      }
    });
  }

  // Toggle User Actions Menu
  function toggleUserActionsMenu(e) {
    e.preventDefault();

    var $target = e.target;

    if ( $userActionsMenu.hasClass('opened') ) {
      hideOpenedBar($userActionsToggler, $userActionsMenu, $target);  // Close User Actions Menu

    } else {
      closeOpenedBars(); // Close Opened Header Bars
      outerClickClosed($userActionsToggler, $userActionsMenu, $target);  // Close User Actions Menu if outer click
      outerKeydownClosed($userActionsToggler, $userActionsMenu, $target);
      openBar($userActionsToggler, $userActionsMenu, userActionsMenuHeight); // Open User Actions Menu
    }

    //ADA
    $('a:first', $userActionsMenu).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        closeOpenedBars(); // Close Opened Header Bars
        $userActionsToggler.trigger('focus');
        hideOpenedBar($userActionsToggler, $userActionsMenu, $target);  // Close User Actions Menu
      }
    });
  }

  function toggleSignInBar(e)  {
    e.preventDefault();
    var signInBarHeight = $('.w-flexible-header__sign-in').outerHeight() + SIGN_IN_ERROR_HEIGHT,
    $target = e.target;

    if ( $signInBar.hasClass('opened') ) {
      hideOpenedBar($signInToggler, $signInBar, $target);  // Close Sign In Bar
      $('#user_session_email', $signInBar).trigger('blur');
      $signInBarHeaderButton.trigger('focus');
    } else {
      closeOpenedBars(); // Close Opened Header Bars
      openBar($signInToggler, $signInBar, signInBarHeight);  // Open  Sign In Bar
      $('#user_session_email', $signInBar).trigger('focus');
      outerClickClosed($signInToggler, $signInBar, $target);// Close Sign In Bar if outer click
      outerKeydownClosed($signInToggler, $signInBar, $target);// Close Sign In Bar if ESCAPE pressed
    }

    //ADA
    $('a:last', $signInBar).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && !e.shiftKey) {
        e.preventDefault();
        $signInBarCloseButton.trigger('focus');
      }
    });

    $signInBarCloseButton.on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && !e.shiftKey) {
        e.preventDefault();
        hideOpenedBar($signInToggler, $signInBar, $target);  // Close Sign In Bar
        $signInBarHeaderButton.trigger('focus');
      }
    });

    $('a:first', $signInBar).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        hideOpenedBar($signInToggler, $signInBar, $target);  // Close Sign In Bar
        $signInBarHeaderButton.trigger('focus');
      }
    });
  }

  function outerClickClosed(link, openedBar, focus) {
    $('body').on('click', function(e) {
      if (openedBar.hasClass('opened')) {
        var $target = $(e.target);
        if ( !$target.is(openedBar) && openedBar.has(e.target).length === 0 && !$target.is(link) && !$target.parent().is(link)) {
          hideOpenedBar(link, openedBar, focus);
          $('body').off('click');

          if ($("input:focus", openedBar).length) {
            $("input:focus", openedBar).trigger('blur');
            focus.trigger('focus');
          }
        }
      }
    });
  }

  function outerKeydownClosed(link, openedBar, focus) {
    $(document).on('keydown', function(e) {
      if (e.keyCode === $.ui.keyCode.ESCAPE) {
        if (openedBar.hasClass('opened')) {
          hideOpenedBar(link, openedBar, focus);
          focus.trigger('focus');

          if ($("input:focus", openedBar).length) {
            $("input:focus", openedBar).trigger('blur');
          }
        }
      }
    });
  }

  function hideOpenedBar(link, openedBar) {
    $('a, input, button', openedBar).attr('tabindex', '-1');
    $('.w-flexible-header__close', openedBar).attr('tabindex', '-1');
    openedBar.removeClass('opened').animate({'height': 0}, 500);
    link.removeClass('active');
  }

  function openBar(link, bar, height) {
    $('a, input, button', bar).removeAttr('tabindex');
    $('.w-flexible-header__close', bar).removeAttr('tabindex');
    bar.addClass('opened').animate({'height': height}, 500);
    link.addClass('active');
  }

  function closeOpenedBars() {
    if ( $('.opened').length ) {
      $('.opened').removeClass('opened').animate({'height': 0}, 500);
      $('.active').removeClass('active');
    }
  }

  // Sign In Form Validation
  function checkRequiredFields() {
    var valid = true,
        emailErrorSpan = $('#email-error', $signInForm),
        passwordErrorSpan = $('#password-error', $signInForm);

    if (0 == $emailField.val().length) {
      valid = false;
      emailErrorSpan.prev().addClass('field_with_errors');
      emailErrorSpan.text('Login cannot be blank.');
    } else {
      emailErrorSpan.text('');
      emailErrorSpan.prev().removeClass('field_with_errors');
    }

    if (0 == $passwordField.val().length) {
      valid = false;
      passwordErrorSpan.prev().addClass('field_with_errors');
      passwordErrorSpan.text('Password cannot be blank.');
    } else {
      passwordErrorSpan.text('');
      passwordErrorSpan.prev().removeClass('field_with_errors');
    }
    return valid;
  }

  function removeErrorMessage() {
    if ($('.sign-in-error').length) {
      $('.sign-in-error').remove();
    }
  }

  // run constructor
  init();

  /* PUBLIC METHODS */
  return {
    // public methods go here
  };
}

// jQuery plugin method
$.fn.wFlexibleHeader = function(options) {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('wFlexibleHeader')) {
      $this.data('wFlexibleHeader', wFlexibleHeader($this, options));
    }
  });
};
